export default "__VITE_ASSET__B$FU3FTv__"